import moment from "moment-timezone";
import { useHistory } from "react-router-dom";
import { BorderButton } from "src/components/buttons/BorderButton";
import { Form, useForm } from "src/components/forms/Form";
import { InputItem } from "src/components/inputs/InputItem";
import { InputText } from "src/components/inputs/InputText";
import { KioskBackButton } from "src/components/kiosk/KioskBackButton";
import Container from "src/components/layout/Container";
import { useStore } from "src/stores/Store";

interface Props {}

export default function KioskName(props: Props) {
  const store = useStore();
  const history = useHistory();
  const form = useForm();
  const today = moment();

  function searchUsers() {
    if (!form.getFieldValue("name")) {
      return;
    }

    const params = new URLSearchParams();
    params.set("search", form.getFieldValue("name").toLowerCase().trim());
    params.set("date", today.format("YYYY-MM-DD"));

    history.push(`/kiosk/results?${params.toString()}`);
  }

  return (
    <Container className="py-4 pt-12">
      <div className="mb-8 flex items-center text-center">
        <div className="flex-1">
          <h1
            className="mb-0 text-7xl font-bold sm:text-3xl"
            css={{
              color: store.theme.orgColor,
            }}
          >
            Enter Your Name
          </h1>
        </div>
        <KioskBackButton />
      </div>

      <Form onSubmit={searchUsers}>
        <div className="flex gap-4">
          <div className="relative flex-1">
            <InputItem
              name="name"
              rules={[{ required: true, message: "Please enter a name" }]}
              form={form}
            >
              <InputText
                placeholder="Name"
                allowClear
                className="h-20 border-8 text-2xl sm:h-12 sm:border-2 sm:text-lg"
              />
            </InputItem>
          </div>
          <div>
            <BorderButton
              type="submit"
              disabled={!form.getFieldValue("name")}
              className="h-20 border-2 border-b-4 px-8 text-2xl sm:h-12 sm:border sm:border-b-2 sm:px-4 sm:text-base"
            >
              Search
            </BorderButton>
          </div>
        </div>
      </Form>
    </Container>
  );
}
